// src/features/employee/EmployeeLeave.js
import React, { useState } from "react";
import "../client/Client.css";
import "../../components/common/Popup.css"; // reuse popup styling

const EmployeeLeave = ({ employeeId }) => {
  const [activeView, setActiveView] = useState("history"); // 'history' or 'request'
  // Maintain per-row status for request view
  const initialRequests = [
    { id: 1, name: "Floyd Miles", type: "Dell", from: "26-08-2024", to: "30-08-2024", duration: "5 Days", reason: "Casual", status: "Reject" },
    { id: 2, name: "Floyd Miles", type: "Acer", from: "26-08-2024", to: "30-08-2024", duration: "5 Days", reason: "Sick", status: "Accepted" },
    { id: 3, name: "Floyd Miles", type: "Titan", from: "26-08-2024", to: "30-08-2024", duration: "5 Days", reason: "Sick", status: "Accepted" },
    { id: 4, name: "Floyd Miles", type: "LG", from: "26-08-2024", to: "30-08-2024", duration: "5 Days", reason: "Comp Off", status: "Reject" }
  ];
  const [requests, setRequests] = useState(initialRequests);
  const [confirmRowId, setConfirmRowId] = useState(null); // row pending reject confirm
  const [pendingStatus, setPendingStatus] = useState(null); // new status awaiting confirmation

  const handleStatusChange = (rowId, newStatus) => {
    // Show confirmation for both Accept and Reject; apply Pending directly
    if (newStatus === "Reject" || newStatus === "Accepted") {
      setConfirmRowId(rowId);
      setPendingStatus(newStatus);
    } else {
      setRequests(prev => prev.map(r => (r.id === rowId ? { ...r, status: newStatus } : r)));
    }
  };

  const confirmReject = () => {
    if (confirmRowId && pendingStatus) {
      setRequests(prev => prev.map(r => (r.id === confirmRowId ? { ...r, status: pendingStatus } : r)));
    }
    setConfirmRowId(null);
    setPendingStatus(null);
  };

  const cancelReject = () => {
    // Simply close; do not apply pending reject
    setConfirmRowId(null);
    setPendingStatus(null);
  };

  return (
    <div className="table-container">
      {/* Leave History / Leave Request Buttons */}
      <div style={{ marginBottom: "24px", display: "flex", gap: "10px", justifyContent: "center" }}>
        <button
          onClick={() => setActiveView("history")}
          style={{
            padding: "10px 30px",
            backgroundColor: activeView === "history" ? "#2d3561" : "#fff",
            color: activeView === "history" ? "#fff" : "#666",
            border: activeView === "history" ? "none" : "1px solid #e0e0e0",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "14px",
            transition: "all 0.3s ease"
          }}
        >
          Leave History
        </button>
        <button
          onClick={() => setActiveView("request")}
          style={{
            padding: "10px 30px",
            backgroundColor: activeView === "request" ? "#2d3561" : "#fff",
            color: activeView === "request" ? "#fff" : "#666",
            border: activeView === "request" ? "none" : "1px solid #e0e0e0",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "14px",
            transition: "all 0.3s ease"
          }}
        >
          Leave Request
        </button>
      </div>

      {/* Leave History View */}
      {activeView === "history" && (
        <table className="table">
          <thead>
            <tr>
              <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>Employee Name</th>
              <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>Leave Type</th>
              <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>From Date</th>
              <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>To Date</th>
              <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>Duration</th>
              <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>Reason</th>
              <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>Floyd Miles</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>Acer</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>26-08-2024</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>30-08-2024</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>5 Days</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>Sick</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>
                <button
                  style={{
                    padding: "8px 24px",
                    backgroundColor: "#fff",
                    color: "#ff4757",
                    border: "1px solid #ff4757",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: "500"
                  }}
                >
                  Reject
                </button>
              </td>
            </tr>
            <tr>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>Floyd Miles</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>Titan</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>26-08-2024</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>30-08-2024</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>5 Days</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>Sick</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>
                <button
                  style={{
                    padding: "8px 24px",
                    backgroundColor: "#fff",
                    color: "#00d4aa",
                    border: "1px solid #00d4aa",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: "500"
                  }}
                >
                  Accept
                </button>
              </td>
            </tr>
            <tr>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>Floyd Miles</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>LG</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>26-08-2024</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>30-08-2024</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>5 Days</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>Comp Off</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>
                <button
                  style={{
                    padding: "8px 24px",
                    backgroundColor: "#fff",
                    color: "#00d4aa",
                    border: "1px solid #00d4aa",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: "500"
                  }}
                >
                  Accept
                </button>
              </td>
            </tr>
            <tr>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>Floyd Miles</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>Asus</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>26-08-2024</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>30-08-2024</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>5 Days</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>Casual</td>
              <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>
                <button
                  style={{
                    padding: "8px 24px",
                    backgroundColor: "#fff",
                    color: "#00d4aa",
                    border: "1px solid #00d4aa",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: "500"
                  }}
                >
                  Accept
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      )}

      {/* Leave Request View */}
      {activeView === "request" && (
        <>
          <table className="table">
            <thead>
              <tr>
                <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>Employee Name</th>
                <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>Leave Type</th>
                <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>From Date</th>
                <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>To Date</th>
                <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>Duration</th>
                <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>Reason</th>
                <th className="th" style={{ padding: "12px 16px", textAlign: "center" }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {requests.map(r => (
                <tr key={r.id}>
                  <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>{r.name}</td>
                  <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>{r.type}</td>
                  <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>{r.from}</td>
                  <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>{r.to}</td>
                  <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>{r.duration}</td>
                  <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>{r.reason}</td>
                  <td className="td" style={{ padding: "20px 16px", textAlign: "center" }}>
                    <select
                      style={{
                        padding: "8px 16px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "13px",
                        backgroundColor: "#fff",
                        minWidth: "120px"
                      }}
                      value={r.status}
                      onChange={e => handleStatusChange(r.id, e.target.value)}
                    >
                      <option value="Reject">Reject</option>
                      <option value="Accepted">Accepted</option>
                      <option value="Pending">Pending</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {confirmRowId !== null && (
            <div className="popup-backdrop">
              {(() => {
                const isAccept = pendingStatus === "Accepted";
                const containerClass = `popup ${isAccept ? "success" : "error"}`;
                const headerText = isAccept
                  ? "Are you sure you want to accept this leave request?"
                  : "Are you sure you want to reject this leave request?";
                const confirmText = isAccept ? "Yes" : "Yes";
                const confirmColor = isAccept ? "#1dad86" : "#1dad86";
                return (
                  <div className={containerClass} style={{ maxWidth: "420px" }}>
                    <h4 style={{ marginBottom: "14px" }}>{headerText}</h4>
                    <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                      <button
                        onClick={confirmReject}
                        style={{
                          padding: "8px 20px",
                          background: confirmColor,
                          border: "none",
                          color: "#fff",
                          borderRadius: "5px",
                          cursor: "pointer",
                          fontWeight: 500
                        }}
                      >
                        {confirmText}
                      </button>
                      <button
                        onClick={cancelReject}
                        style={{
                          padding: "8px 20px",
                          background: "#e74c3c",
                          border: "none",
                          color: "#fff",
                          borderRadius: "5px",
                          cursor: "pointer",
                          fontWeight: 500
                        }}
                      >
                        Can
                      </button>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default EmployeeLeave;
